export default class Search {
  constructor(searchHolder) {
    this.holder = searchHolder
    this.searchField = this.holder.querySelector('.js-search-input')
    this.searchFieldRestBtn = this.holder.querySelector('.js-search-input-reset')
    this.searchFieldRow = this.holder.querySelector('.js-search-input-row')
    this.focusClass = 'js-search-focused'

    this.init()
  }

  init() {
    this.addClassOnFocus()
    this.attachHandlers()
  }

  attachHandlers() {
    this.searchField.addEventListener('input', this.addClassOnFocus.bind(this))
    this.searchFieldRestBtn.addEventListener('click', this.resetSearchFieldValue.bind(this))
  }

  addClassOnFocus() {
    if (this.checkIfSearchFieldIsEmpty()) {
      this.searchFieldRow.classList.add(this.focusClass)
    } else if (!this.checkIfSearchFieldIsEmpty() && this.searchFieldRow.classList.contains(this.focusClass)) {
      this.searchFieldRow.classList.remove(this.focusClass)
    }
  }

  checkIfSearchFieldIsEmpty() {
    const val = this.searchField.value.trim()
    return val.length > 0
  }

  resetSearchFieldValue() {
    this.searchField.value = ''
    this.searchFieldRow.classList.remove(this.focusClass)
  }
}